"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var styles = {
  "editable": "editable_2dGL07",
  "no-editable": "no-editable_3ZaHAU",
  "noEditable": "no-editable_3ZaHAU"
}; 
require('./OverviewRow.css');
var OverviewRow = function OverviewRow(_ref) {
  var title = _ref.title,
    testId = _ref.testId,
    _ref$isEditable = _ref.isEditable,
    isEditable = _ref$isEditable === void 0 ? false : _ref$isEditable,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("tr", {
    "data-test-id": "".concat(testId, "-tr")
  }, /*#__PURE__*/_react.default.createElement("th", {
    scope: "col"
  }, title), /*#__PURE__*/_react.default.createElement("td", {
    "data-test-id": testId,
    className: isEditable ? styles.editable : styles.noEditable
  }, children));
};
var _default = exports.default = OverviewRow;
//# sourceMappingURL=OverviewRow.js.map